import { TableField } from "@zapier/canvas-state";

import { Icon } from "@zapier/design-system";
import ListItems from "./ListItems";
import styles from "./StepDetails.module.css";

const getIcon = (type: string) => {
  if (type === "email") return "actionEmail";
  if (["text", "string"].includes(type)) return "formText";
  if (type === "datetime") return "actionCalendar";

  return "alertInfo";
};

interface TableDetailsProps {
  fields: TableField[];
}

export function TableDetails({ fields }: TableDetailsProps) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.section}>
        <div className={styles.sectionLabel}>
          Fields
          <div className={styles.count}>{fields.length}</div>
        </div>
        {fields.length === 0 ? (
          <ListItems
            items={[{}].map(() => ({
              icon: <Icon name="navTable" size={14} />,
              text: "Empty",
            }))}
          />
        ) : (
          <ListItems
            items={fields.map((field) => ({
              text: field.name,
              icon: <Icon name={getIcon(field.type)} size={14} />,
              rightIcon: field.options?.button ? (
                <Icon name="miscBoltAltFill" color="BrandOrange" size={14} />
              ) : null,
            }))}
          />
        )}
      </div>
    </div>
  );
}
